// extracted by mini-css-extract-plugin
export default {"align-cc":"Layout_align-cc__D-Zpf","align-lc":"Layout_align-lc__WT6kf","align-rc":"Layout_align-rc__u0NhV","layout":"Layout_layout__Lg9ze"};